import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams }) {
		try {
			// const usePlCd = searchParams.usePlCd.length > 1 ? searchParams.usePlCd.join(',') : searchParams.usePlCd;
			const queryStr = objectToQueryString({
				startMm: searchParams.strDt.replaceAll('-', ''),
				period: searchParams.period
			});
			const response = await client.get(`${BASE_URL}/mmc/mmcm/torqStts/v1/torqSttss${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
